<template>
  <div id="super-mobile-version" class="box">
    <WtTitle size="h2">
      <span class="pr-2">Mobile App Version Control</span>
    </WtTitle>

    <WtTitle size="h6">
      <span class="pr-6">
        You will need to get the build numbers from the mobile development team
        to properly fill in the forms below.
      </span>
    </WtTitle>

    <div class="card mb-4">
      <div class="card-content no-padding">
        <WtTitle size="h4">Android</WtTitle>
        <MobileSupportForm platform="android" />
        <br />
        <WtTitle size="h4">iOS</WtTitle>
        <MobileSupportForm platform="ios" />
      </div>
    </div>
  </div>
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle.vue";
import MobileSupportForm from "@@/MobileSupportForm.vue";

export default {
  name: "AdminSuperMobileSupport",
  components: { MobileSupportForm, WtTitle }
};
</script>
